import { useMutation } from '@apollo/client'
import { AddVaccinationRecord, AddVaccinationRecordVariables } from '../../types'
import { ADD_VACCINATION_RECORD } from './operations'

export const useAddVaccinationRecord = () =>
  useMutation<AddVaccinationRecord, AddVaccinationRecordVariables>(ADD_VACCINATION_RECORD)
